module.exports = __webpack_public_path__ + "img/Image34.3077c480.jpg";